const date_time = {
	day: "Tag",
	month: "Monat",
	month_list: [
		"Januar",
		"Februar",
		"März",
		"April",
		"Mai",
		"Juni",
		"Juli",
		"August",
		"September",
		"Oktober",
		"November",
		"Dezember",
	],
	year: "Jahr",
};

export default date_time;
